import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';

import { ConsignorService } from '../ApplicationServices/ConsignorService';
import { ConsigneeService } from '../ApplicationServices/ConsigneeService';

import { ConsignorElement } from '../models/ConsignorModel';
import { ConsigneeElement } from '../models/ConsigneeModel';

import { SharedService } from '../ApplicationServices/SharedService';
import { WindowRef } from "../ApplicationServices/WindowRefService";
import { ItemModifierService } from "../ApplicationServices/ItemModifierServices";
import { LoginService } from "../ApplicationServices/LoginService";
import { UserInfoStore } from "../shared/store/userInfo.store";
// import { Router } from "@angular/router";

declare global {
  interface Window { MyNamespace: any;callapi:any }
}

window.MyNamespace = window.MyNamespace || {};

window.callapi=function(){

var xhttp = new XMLHttpRequest();
xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {

         //window.MyNamespace=""+window.MyNamespace+"";
        if( window.MyNamespace == xhttp.response.replace(/^"|"$/g, '') ){

         // alert("Payment Proceed Successfully 2!");
           // this.ShowSuccess();



         }

    }


};

var url="https://adminapis.hideandskin.in/api/CommonWeb/GetHashCode?mes="+sessionStorage.getItem("RazorOrder_Id") + "|" + sessionStorage.getItem("RazorPayment_Id")+"&sec="+"l9JfT9Gfsm2S0kwbY0xRz8Jy";
xhttp.open("GET", url, true);
xhttp.send();
//alert("Payment Proceed Successfully 211!");



}



@Component({
  selector: 'app-proceedpayment',
  templateUrl: './proceedpayment.component.html',
  styleUrls: ['./proceedpayment.component.scss']
})

export class ProceedpaymentComponent implements OnInit {


    invoiceamt: string = null ;
    iamt: number = 0;
    mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";
    isValidFormSubmitted = false;

    IP: number = 0; IPS: number = 0;
    alertmsg111: string = null;showalert111: boolean = false;
    alertmsg222: string = null;showalert222: boolean = false;

    cartItems = [];
    billingaddress = [];   shippingaddress = [];
    closeResult: string;
    alertmsg: string = null;
    showalert: boolean = false;
    showAlert1: boolean = false;
    showAlert2: boolean = false;

    alertmsg11: string = null;
    showalert11: boolean = false;

    alertmsg22: string = null;

    stt: string = null;
    showalert22: boolean = false;

     str: any = null;
     operationstate: number = 0;


     ITS: number = 0;
     IDS: number = 0;  PID: number = 0;

     newproductData: any;
     countryData:any;
     stateData:any;
     cityData:any;

      paymenttypeData:any;
      ordershippingData:any;
      orderpaymentmodeData:any;

      PaymentForm: FormGroup;
      ConsigneeForm: FormGroup;
      ConsignorForm: FormGroup;
      AddressSelectionForm: FormGroup;
      AddressSelectionFormConsignee: FormGroup; AddressSelectionFormConsignor: FormGroup;
      submitted = false;
      consignorsubmitted = false;




  razorPayoptions = {

    key: "rzp_live_56cRurkINfLrXS", // Enter the Key ID generated from the Dashboard  rzp_live_sqSX9RLQxyo1Re

     //amount: sessionStorage.getItem("RazorAmount"), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    //amount: 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise

       //  sessionStorage.setItem("RazorAmount",event[0].OperationStatus);
      //amount: sessionStorage.getItem("RazorAmount"), // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
    
    //amount:((this.iamt) * 100),

    amount: sessionStorage.getItem("RazorAmount"),
    currency: "INR",
    name: "Leather N Leather",
    description: "Hide & Skin Payment Gateway",
    //image: "http://integraffsandboximgvcd.integraff.com/INTEGRAFFIMG/HIDEANDSKIN/OTH/MISCELLANEOUS/L111.jpg",
    order_id: sessionStorage.getItem("RazorOrder_Id"), //This is a sample Order ID. Pass the `id` obtained in the response of Step 1

    handler: function (response) {
      //alert(window.MyNamespace);
      // sessionStorage.setItem("RazorOrder_Id", event.id);
      sessionStorage.setItem("RazorPayment_Id",response.razorpay_payment_id);
      sessionStorage.setItem("RazorOrder_Id",response.razorpay_order_id);
      //sessionStorage.setItem("RazorSignature_Id",response.razorpay_signature.replace(/^"|"$/g,''));
      sessionStorage.setItem("RazorSignature_Id",response.razorpay_signature);
      //sessionStorage.setItem("RazorSUCCESS","SUCCESS");

      //alert(response.razorpay_payment_id);
      ////alert(response.razorpay_order_id);
      //alert(response.razorpay_signature);



         //  this.shareService.getHashCodeDataHMACSHA256( sessionStorage.getItem("RazorOrder_Id") + "|" + sessionStorage.getItem("RazorPayment_Id") , "9qRKw7VD1AMoCpzW6FE5Ulm5").subscribe
        // (result => {
       //   var strin=   result;
      //  this.str= result;

         //window.MyNamespace = ""+""+""+response.razorpay_signature+""+""+"";
        //window.MyNamespace = response.razorpay_signature.replace(/^"|"$/g,'');
        window.MyNamespace = response.razorpay_signature;
        window.callapi();


        alert("Order Placed Successfully !! ");
        alert("Payment Proceed Successfully !");
        var r = confirm("Press a button to confirm !");
        if (r == true) {
          window.location.href = "https://hideandskin.in/#/thankingyou";
        } else {
          window.location.href = "https://hideandskin.in/#/thankingyou";
        }


        // if (sessionStorage.getItem("OrderMaster_Id")) {
        //   var item = {
        //     Id: 0,
        //     OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
        //     OrderPaymentTypeId:  sessionStorage.getItem("RazorPID"),
        //     OperationType: "order placed",
        //     RazorOrderId: sessionStorage.getItem("RazorOrder_Id"),
        //     RazorPaymentId: sessionStorage.getItem("RazorPayment_Id"),

        //   };
        //   this.itemModifierService.addItemToCart(item).subscribe((event) => {
        //     if (event) {
        //       console.log(event);
        //      this.getCartInfo();
        //     }
        //   });
        // }



       // });


    },

    prefill: {
      name: "",
      email: "",
      contact: "",
    },
    notes: {
      address: "Razorpay Corporate Office",
    },
    theme: {
      color: "#3399cc",
    },


   // alert("Payment Proceed Successfully 11!");

  };

  public initPay(): void {


          //modify Id of razorPayOpptions
         // this.razorPayoptions.order_id="order_G4c4cFx4e1ySDl";

        //  this.razorPayoptions.key="rzp_live_sqSX9RLQxyo1Re";
       //  this.razorPayoptions.currency="INR";
      //  this.razorPayoptions.name="Leather N Leather";
     //  this.razorPayoptions.description="Hide And Skin Transation";

    //  this.razorPayoptions.amount= sessionStorage.getItem("RazorOrder_Id");
   //  this.razorPayoptions.order_id= sessionStorage.getItem("RazorAmount");
  //  this.razorPayoptions.image="http://integraffsandboximgvcd.integraff.com/INTEGRAFFIMG/HIDEANDSKIN/OTH/MISCELLANEOUS/L1.jpg";


  //this.ITS = 1;



  // if (sessionStorage.getItem("OrderMaster_Id")) {

  //   this.itemModifierService
  //     .getCartItemsOrderedAmt(parseInt(sessionStorage.getItem("OrderMaster_Id")))
  //     .subscribe((event: any) => {
  //      if (event.length > 0) {     
        
  //           sessionStorage.setItem("RazorAmount",event[0].OperationStatus);
  //           this.cartItems = event;            

  //       }
  //     });
  // }




    if( this.alertmsg11 == "No Records" || this.alertmsg22 == "No Records" ){

      this.alertmsg = "Billing Address & Shipping Address can not be blank !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 3000);

      return;

    }
    else
    {


    if( this.PaymentForm.get('OrderPaymentTypeId').value=="2" ){

       // COD
      //sessionStorage.setItem("RazorOrder_Id", event);

      sessionStorage.setItem("RazorOrder_Id","");
      sessionStorage.setItem("RazorPayment_Id","");

      this.PlaceOrder();
      this.PID=2;
      this.alertmsg = "Order Placed Successfully !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 30000);

      this.router.navigateByUrl("thankingyou");

      return;

      // https://hideandskin.in/#/orders

    }
    else if(  this.PaymentForm.get('OrderPaymentTypeId').value=="1" )
    {
      // NA
      this.PID=0;
      this.alertmsg = "Choose Particular Payment Category !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 3000);
      return;

    }
    else
    {

      //this.router.navigateByUrl("proceedpayment");

      //  ONLINE
      // sessionStorage.setItem("RazorPayment_Id","");
      // sessionStorage.setItem("RazorOrder_Id","");
      // sessionStorage.setItem("RazorSignature_Id","");
      // sessionStorage.setItem("RazorSUCCESS","");
      // sessionStorage.setItem("RazorPID","");
      // sessionStorage.setItem("OrderMaster_Id","");

       //this.PlaceOrder();
      //this.PID=3;

      // this.alertmsg = "Order Placed Successfully !";
      // this.showalert = true;
      // setTimeout(() => {
      //   this.showalert = false;
      // }, 30000);
      //this.router.navigateByUrl("thankingyou");
      //return;

      sessionStorage.setItem("RazorOrder_Id","");
      sessionStorage.setItem("RazorPayment_Id","");

      if (sessionStorage.getItem("OrderMaster_Id")) {

        this.itemModifierService
          .getCartItemsOrderedAmt(parseInt(sessionStorage.getItem("OrderMaster_Id")))
          .subscribe((event: any) => {
            if (event.length > 0) {


           
               //var ii = event[0].OperationStatus;
              // var jj = ii * 100 ; 
              //sessionStorage.setItem("RazorAmount",event[0].OperationStatus);

             // sessionStorage.setItem("RazorAmount",jj.toString());

                 // this.cartItems = event;
                // if (event[0].OperationStatus == "Successfully Saved") {
               //   alert("done");
              // }

            }
          });

         // sessionStorage.setItem("RazorAmount",this.invoiceamt);
      }


      this.PlaceOrder();
      this.PID=3;
      this.alertmsg = "Order Placed Successfully !";
      this.showalert = true;
      setTimeout(() => {
        this.showalert = false;
      }, 30000);          

      this.router.navigateByUrl("thankingyou");

      const formData = new FormData();
      var obj ={};
       obj = {

        amount: sessionStorage.getItem("RazorAmount"),
        // amount: ((this.iamt) * 100 ) ,
        currency: "INR",
        receipt: (sessionStorage.getItem("OrderMaster_Id")),
      };
      formData.append("params", JSON.stringify(obj));
      this.loginService.RazorcreateOrder(obj).subscribe((event: any) => {
          sessionStorage.setItem("RazorOrder_Id", event);
      });


      this.PID=this.PaymentForm.get('OrderPaymentTypeId').value;
      sessionStorage.setItem("RazorPID",this.PID.toString());
      var x=JSON.parse(JSON.stringify(this.razorPayoptions)) ;
      var rzp1 = new this.winRef.nativeWindow.Razorpay(x);
      rzp1.open();

    
      //  sessionStorage.setItem("RazorPayment_Id","");
      // sessionStorage.setItem("RazorOrder_Id","");
      // sessionStorage.setItem("RazorSignature_Id","");
      // sessionStorage.setItem("RazorSUCCESS","");
      // sessionStorage.setItem("RazorPID","");
      // sessionStorage.setItem("OrderMaster_Id","");
      
      //return;

      // sessionStorage.removeItem("RazorAmount");


       // rzp1.on("response.razorpay_signature", function (response) {
      //  this.router.navigateByUrl("   thankingyou");
      //   //

      //  });

      //this.router.navigateByUrl("thankingyou");

   
      // return;

      // https://hideandskin.in/#/orders

      // this.alertmsg = "Order Placed Successfully !";
      // this.showalert = true;
      // setTimeout(() => {
      //   this.showalert = false;
      // }, 3000);
     // return;


    }




    // this.alertmsg = "Payment Proceed Successfully !";
    // this.showalert = true;
    // setTimeout(() => {
    //   this.showalert = false;
    // }, 9000);

   // alert("Payment Proceed Successfully 6662!");

     /*
    this.shareService.getHashCodeDataHMACSHA256( sessionStorage.getItem("RazorOrder_Id") + "|" + sessionStorage.getItem("RazorPayment_Id") , "9qRKw7VD1AMoCpzW6FE5Ulm5").subscribe
         (result => {
         // this.str= result;

         // this.stt = JSON.stringify(result);

        // window.MyNamespace=result;
         rzp1.open();

        });

        */

    // rzp1.on("payment.captured", function (response) {

    //   if(  sessionStorage.getItem("RazorSUCCESS")=="" ){

    //   }else{

    //     this.shareService.getHashCodeDataHMACSHA256( sessionStorage.getItem("RazorOrder_Id") + "|" + sessionStorage.getItem("RazorPayment_Id") , "9qRKw7VD1AMoCpzW6FE5Ulm5").subscribe
    //     (result => {

    //     this.str= result;

    //     if(  this.str == sessionStorage.getItem("RazorSignature_Id")){

    //       this.alertmsg = "PAYMENT SUCCESS !";
    //       this.showalert = true;
    //       setTimeout(() => {
    //         this.showalert = false;
    //       }, 3000);

    //       this.PlaceOrder();
    //       this.PID=3;
    
    //       this.alertmsg = "Order Placed Successfully !";
    //       this.showalert = true;
    //       setTimeout(() => {
    //         this.showalert = false;
    //       }, 30000);
    //       this.router.navigateByUrl("thankingyou");
    //       return;

    //     }else{

    //       this.alertmsg = "PAYMENT FAILED !";
    //       this.showalert = true;
    //       setTimeout(() => {
    //         this.showalert = false;
    //       }, 3000);
    //     }
    //      });

    //   }

    // });


    // rzp1.open();


      rzp1.on("payment.failed", function (response) {
       // alert(response.error.code);
      //  alert(response.error.description);
      //  alert(response.error.source);
     //   alert(response.error.step);
     //   alert(response.error.reason);
     //   alert(response.error.metadata.order_id);
     //   alert(response.error.metadata.payment_id);

     alert("Payment Failed !");

      });

    }


  //}





    sessionStorage.setItem("RazorPayment_Id","");
    sessionStorage.setItem("RazorOrder_Id","");
    sessionStorage.setItem("RazorSignature_Id","");
    sessionStorage.setItem("RazorSUCCESS","");

  }



  PlaceOrder(){

    //  this.generateForm.value.CurrentAmount;

    if (sessionStorage.getItem("OrderMaster_Id")) {
      var item =
      {

        Id: 0,
        OrderMaster_Id: parseInt(sessionStorage.getItem("OrderMaster_Id")),
         //CreatedBy: Number(sessionStorage.getItem("UID")), this.PaymentForm.get('OrderPaymentTypeId').value
        //OrderPaymentTypeId: this.PaymentForm.get('OrderPaymentTypeId').value,
        OrderPaymentTypeId: this.PaymentForm.value.OrderPaymentTypeId,
        OperationType: "order placed",
        RazorOrderId: sessionStorage.getItem("RazorOrder_Id"),
        RazorPaymentId: sessionStorage.getItem("RazorPayment_Id"),
        CouponAmt: sessionStorage.getItem("CouponAmt"),

        // sessionStorage.setItem("CouponAmt", this.total1.toString());
           //  sessionStorage.getItem("RazorOrder_Id");
          // sessionStorage.getItem("RazorPayment_Id");

      };


      this.itemModifierService.addItemToCart(item).subscribe((event) => {
        if (event) {
          console.log(event);

          // str1= data[0].OperationStatus.toString().split('#')[0];
          var str2= event[0].OperationStatus.toString().split('#')[1];

          this.itemModifierService.SendingSMSOrMailData(str2).subscribe((event2) => {
            
            console.log(event2);

          });

          this.getCartInfo();

              // if (event[0].OperationStatus == "Successfully Deleted") {
             //      //alert("Add To Cart Successfully !");
            //this.FillCart();
           //    // this.getCartInfo();
          // }


        }
      });
    } else {
      alert("Please Login");
    }




  }


  getCartInfo() {
    if (sessionStorage.getItem("OrderMaster_Id")) {
      this.itemModifierService
        .getCartItems(parseInt(sessionStorage.getItem("OrderMaster_Id")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.infoStore.setCartInfo(event);
          } else {
            this.infoStore.setCartInfo([]);
          }
        });
    } else {
      this.infoStore.setCartInfo([]);
    }
  }


      constructor(

        private infoStore: UserInfoStore,
        private loginService: LoginService,
        private formBuilder: FormBuilder,private modalService: NgbModal,
        private cnorService: ConsignorService, private cneeService: ConsigneeService,
        private shareService: SharedService,
        private winRef: WindowRef,       
        private itemModifierService: ItemModifierService,
        private router: Router,
        private route: ActivatedRoute,

        ) {

          
              // this.route.queryParams.subscribe(params => {
             //   this.invoiceamt = params['invoiceamts'];
            //   this.iamt =  Number(this.invoiceamt) ;
           //    //sessionStorage.getItem("RazorAmount")
          //   //sessionStorage.setItem("RazorAmount",  this.invoiceamt );        
         // })


      this.AddressSelectionForm = this.formBuilder.group({
        adresses: [""],
      });

      this.AddressSelectionFormConsignor = this.formBuilder.group({
        billingaddress: [""],
      });

      this.AddressSelectionFormConsignee = this.formBuilder.group({
        shippingaddress: [""],
      });

      this.ConsigneeForm = this.formBuilder.group({

        ConsigneeId:[0, Validators.required],
        State_Id: [2, Validators.required],
        City_Id: ["", Validators.required],
        FullName: ["", Validators.required],
        MobileNumber: ["", Validators.required],
        //MobileNumber: ["", [Validators.required, Validators.pattern("^((\+91-?)|0)?[0-9]{10}$")]],
        PinCode: ["", Validators.required],

        FlatHouseNoBuildingCompanyApartment: ["", Validators.required],
        AreaColonyStreetSectorVillage: ["", Validators.required],
        LandMark: ["", Validators.required],
        SetDefault: ["YES",Validators.required],

      });
      this.ConsignorForm = this.formBuilder.group({

        ConsignorId:[0, Validators.required],
        State_Id: [2, Validators.required],
        City_Id: [1, Validators.required],
        FullName: ["", Validators.required],
        MobileNumber: ["", Validators.required],
        PinCode: ["", Validators.required],

        FlatHouseNoBuildingCompanyApartment: ["", Validators.required],
        AreaColonyStreetSectorVillage: ["", Validators.required],
        LandMark: ["", Validators.required],
        SetDefault: ["YES",Validators.required],
        IsBillShippingAddressSame: "NO",

      });


      this.PaymentForm = this.formBuilder.group({

          OrderPaymentTypeId:[2, Validators.required],
          // Payment_Type_Id: [1, Validators.required],


      });


      }



      ngOnInit() {

        sessionStorage.setItem("ProceedPay_Id", "1");

         //this.FillBillingAddressData();
        //this.FillShippingAddressData();

         // this.alertmsg11 = "Access Denied !";
        // this.showalert11 = true;

          // sessionStorage.setItem("RazorSUCCESS","");
         //sessionStorage.setItem("RazorAmount","20000");
        // FillCartAmt

      this.FillCartAmt();
      this.getShippingList();
      this.getPaymentOptions();

      this.FillBillingAddressData();
      this.FillShippingAddressData();

      this.getNewProductList();
      this.shareService.getAllFillStateByCountryIdData(101)
      .subscribe(
      (datast) => {
      this.stateData = datast;}
      );

      this.shareService.getAllFillCityByStateIdData(0)
      .subscribe(
        (datact) => {
      this.cityData = datact; }
      );
        //this.getPaymentList();

      this.ConsignorForm.patchValue({IsBillShippingAddressSame:"NO"});


      }


      FillCartAmt(){

        if (sessionStorage.getItem("OrderMaster_Id")) {

          this.itemModifierService
            .getCartItemsOrderedAmt(parseInt(sessionStorage.getItem("OrderMaster_Id")))
            .subscribe((event: any) => {
              if (event.length > 0) {

               // var ii = event[0].OperationStatus;
               // var jj = ii * 100 ; 
                // sessionStorage.setItem("RazorAmount",event[0].OperationStatus);
                //sessionStorage.setItem("RazorAmount",jj.toString());
                
                // sessionStorage.setItem("RazorAmount",event[0].OperationStatus);

                    this.cartItems = event;
                  // if (event[0].OperationStatus == "Successfully Saved") {
                 //   alert("done");
                // }

              }
            });
        }

       // this.invoiceamt 
      // sessionStorage.setItem("RazorAmount",this.invoiceamt);

      }


      getPaymentOptions(){

        this.shareService.getAllPersonPaymentModeOnlineData()
        .subscribe(
          (datact1) => {
        this.orderpaymentmodeData = datact1; }
        );

      }


      getShippingList(){

        this.shareService.getAllStatusShippingDeliveryData()
        .subscribe(
          (datact) => {
        this.ordershippingData = datact; }
        );


      }



      getNewProductList() {
      this.newproductData = [
        { ViewStateNewProduct: "NO" },
        { ViewStateNewProduct: "YES" },
      ];
      }

      onOptionsSelectedState(value){
      console.log(value);
        this.shareService.getAllFillCityByStateIdData(value)
        .subscribe(
          (datact) => {

            this.cityData = datact;

          }

        );
      }






    get selectedAdress() {
      return this.AddressSelectionFormConsignor.get("billingaddress").value;
      //return this.AddressSelectionFormConsignee.get("shippingaddress").value;
    }

    get selectedAdressShipping() {
      return this.AddressSelectionFormConsignee.get("shippingaddress").value;
    }






    onConsigneeAdd() {


      // this.consignorsubmitted = true;
    //  console.log(this.ConsignorForm.value);

      //call the service here

     if(

      this.ConsigneeForm.value.State_Id=='' ||
      this.ConsigneeForm.value.FullName==''||
      this.ConsigneeForm.value.MobileNumber==''|| this.ConsigneeForm.value.PinCode==''||
      this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment==''|| this.ConsigneeForm.value.AreaColonyStreetSectorVillage==''||
      this.ConsigneeForm.value.LandMark=='' ||
      this.ConsigneeForm.value.State_Id==null ||
      this.ConsigneeForm.value.FullName==null||
      this.ConsigneeForm.value.MobileNumber==null|| this.ConsigneeForm.value.PinCode==null||
      this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment==null|| this.ConsigneeForm.value.AreaColonyStreetSectorVillage==null||
      this.ConsigneeForm.value.LandMark==null

      )
      {

       this.alertmsg222 = "Required Fields Must Be Filled !!";
       this.showalert222 = true;
       setTimeout(() => {
         this.showalert222 = false;
       }, 2000);

      }else{


        var firstVal = this.ConsigneeForm.value.MobileNumber;
        this.IP=firstVal.length;
        if( this.IP == 10) {
        }
        else{
          this.alertmsg222 = "Mobile Number is not in correct format of 10 digits";
          this.showalert222 = true;
          setTimeout(() => {
            this.showalert222 = false;
          }, 5000);
          return;
        }


        var firstVal1 = this.ConsigneeForm.value.PinCode;
        this.IPS=firstVal1.length;
        if( this.IPS == 6) {
        }
        else{
          this.alertmsg222 = "Pin Code is not in correct format of 6 digits";
          this.showalert222 = true;
          setTimeout(() => {
            this.showalert222 = false;
          }, 5000);
          return;
        }

       var objj = new ConsigneeElement();

       // objj.ConsignorId = 0;

       if( this.operationstate==0){

         objj.ConsigneeId = 0;
         objj.OperationType= "insert";

       }else{

         objj.ConsigneeId = this.IDS;
         objj.OperationType= "update";

       }

       objj.Country_Id =101;
       objj.MobileNumber=this.ConsigneeForm.value.MobileNumber;
       objj.State_Id =this.ConsigneeForm.value.State_Id;
       objj.City_Id =this.ConsigneeForm.value.City_Id;
       objj.FullName =this.ConsigneeForm.value.FullName;
       objj.PinCode =this.ConsigneeForm.value.PinCode;
       objj.FlatHouseNoBuildingCompanyApartment =this.ConsigneeForm.value.FlatHouseNoBuildingCompanyApartment;
       objj.AreaColonyStreetSectorVillage =this.ConsigneeForm.value.AreaColonyStreetSectorVillage;
       objj.LandMark =this.ConsigneeForm.value.LandMark;

       if( this.ConsigneeForm.value.SetDefault=='' || this.ConsigneeForm.value.SetDefault==null ){
         objj.SetDefault =0;
       }
       else  if( this.ConsigneeForm.value.SetDefault=='YES')
       {
         objj.SetDefault =1;
       }
       else{
         objj.SetDefault =0;
       }

       objj.CreatedBy = Number(sessionStorage.getItem("UID"));

       this.cneeService.insertConsigneeData(objj).subscribe((event: any) => {
           if (event && event.length > 0) {
             console.log(event);
             if (event[0].OperationStatus == "Successfully Saved") {

               this.alertmsg = "Billing Address Saved Successfully !";

               this.ConsigneeForm.reset();
               this.FillShippingAddressData();
               this.operationstate=0;

             }
             else
             {

               //this.alertmsg = event[0].OperationStatus;
               this.ConsigneeForm.reset();
               this.FillShippingAddressData();
               this.operationstate=0;

             }
             this.showalert = true;
             setTimeout(() => {
               this.showalert = false;
             }, 3000);
           }
         });


      }

      this.FillBillingAddressData();
      this.FillShippingAddressData();

    }

    onConsignorAdd() {

        // this.consignorsubmitted = true;
       //  console.log(this.ConsignorForm.value);
      //call the service here

     if(

     this.ConsignorForm.value.State_Id=='' ||
     this.ConsignorForm.value.FullName==''||
     this.ConsignorForm.value.MobileNumber==''|| this.ConsignorForm.value.PinCode==''||
     this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment==''|| this.ConsignorForm.value.AreaColonyStreetSectorVillage==''||
     this.ConsignorForm.value.LandMark=='' ||
     this.ConsignorForm.value.State_Id==null ||
     this.ConsignorForm.value.FullName==null||
     this.ConsignorForm.value.MobileNumber==null|| this.ConsignorForm.value.PinCode==null||
     this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment==null|| this.ConsignorForm.value.AreaColonyStreetSectorVillage==null||
     this.ConsignorForm.value.LandMark==null

     )
     {

      this.alertmsg111 = "Required Fields Must Be Filled !!";
      this.showalert111 = true;
      setTimeout(() => {
        this.showalert111 = false;
      }, 2000);

     }else{



      var firstVal = this.ConsignorForm.value.MobileNumber;
      this.IP=firstVal.length;
      if( this.IP == 10) {
      }
      else{
        this.alertmsg111 = "Mobile Number is not in correct format of 10 digits";
        this.showalert111 = true;
        setTimeout(() => {
          this.showalert111 = false;
        }, 5000);
        return;
      }


      var firstVal1 = this.ConsignorForm.value.PinCode;
      this.IPS=firstVal1.length;
      if( this.IPS == 6) {
      }
      else{
        this.alertmsg111 = "Pin Code is not in correct format of 6 digits";
        this.showalert111 = true;
        setTimeout(() => {
          this.showalert111 = false;
        }, 5000);
        return;
      }

      var objj = new ConsignorElement();

      // objj.ConsignorId = 0;

      if( this.operationstate==0){

        objj.ConsignorId = 0;
        objj.OperationType= "insert";

      }else{

        objj.ConsignorId = this.IDS;
        objj.OperationType= "update";

      }

      objj.Country_Id =101;
      objj.MobileNumber=this.ConsignorForm.value.MobileNumber;
      objj.State_Id =this.ConsignorForm.value.State_Id;
      objj.City_Id =this.ConsignorForm.value.City_Id;
      objj.FullName =this.ConsignorForm.value.FullName;
      objj.PinCode =this.ConsignorForm.value.PinCode;
      objj.FlatHouseNoBuildingCompanyApartment =this.ConsignorForm.value.FlatHouseNoBuildingCompanyApartment;
      objj.AreaColonyStreetSectorVillage =this.ConsignorForm.value.AreaColonyStreetSectorVillage;
      objj.LandMark =this.ConsignorForm.value.LandMark;
      objj.IsBillShippingAddressSame=this.ConsignorForm.value.IsBillShippingAddressSame;

      if( this.ConsignorForm.value.SetDefault=='' || this.ConsignorForm.value.SetDefault==null ){
        objj.SetDefault =0;
      }
      else  if( this.ConsignorForm.value.SetDefault=='YES')
      {
        objj.SetDefault =1;
      }
      else{
        objj.SetDefault =0;
      }

      objj.CreatedBy = Number(sessionStorage.getItem("UID"));


      this.cnorService.insertConsignorData(objj).subscribe((event: any) => {
          if (event && event.length > 0) {
            console.log(event);
            if (event[0].OperationStatus == "Successfully Saved") {

              this.alertmsg = "Billing Address Saved Successfully !";

              this.ConsignorForm.reset();
              this.FillBillingAddressData();
              this.operationstate=0;

            }
            else
            {
              //this.alertmsg = event[0].OperationStatus;
              this.ConsignorForm.reset();
              this.FillBillingAddressData();
              this.operationstate=0;

            }
            this.showalert = true;
            setTimeout(() => {
              this.showalert = false;
            }, 3000);
          }
        });

     }

     //this.FillBillingAddressData();
     this.FillShippingAddressData();

    }




    FillBillingAddressData(){
      this.cnorService
        .getAllConsignorMasterByUserIdData(parseInt(sessionStorage.getItem("UID")))
        .subscribe((event: any) => {
          if (event.length > 0) {
            this.billingaddress = event;

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }

             this.alertmsg11 = "Select Particular Record & Click on Edit / Delete Button";
             this.showalert11 = true;

          } else {

            this.billingaddress = [];
            this.alertmsg11 = "No Records";
            this.showalert11 = true;

          }
        });


    }


    FillShippingAddressData(){
      this.cneeService
        .getAllConsigneeMasterByUserIdData(parseInt(sessionStorage.getItem("UID")))
        .subscribe((event: any) => {
          if (event.length > 0) {



            this.alertmsg22 = "Select Particular Record & Click on Edit / Delete Button";
            this.showalert22 = true;

            this.shippingaddress = event;

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }

          } else {


            this.alertmsg22 = "No Records";
            this.showalert22 = true;

            this.shippingaddress = [];


          }
        });


    }




    get f() {
      return this.ConsigneeForm.controls;
    }

    // convenience getter for easy access to form fields
    get r() {
      return this.ConsignorForm.controls;
    }


    SetDefaultConsignee() {
      console.log(this.AddressSelectionForm.value);
    }

    SetDefaultConsignor() {
      console.log(this.AddressSelectionForm.value);
    }




    editAddressBilling(id){

      this.IDS=id;
      this.operationstate=1;
      var comp = null;
      this.cnorService
        .getAllConsignorMasterByConsignorIdData(id)
        .subscribe((event: any) => {
          if (event.length > 0) {
            comp = event;


        //  this.shareService.getAllFillStateByCountryIdData(event.CountryId)
        //  .subscribe(
        //   (datast2) => {
        //  this.stateData = datast2;}
        //   );

          this.shareService.getAllFillCityByStateIdData(event.StateId)
          .subscribe(
            (datact3) => {
          this.cityData = datact3; }
          );

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }
            this.ConsignorForm.setValue({

              ConsignorId : id,
              //Country_Id :101,
              MobileNumber:event[0].MobileNumber,
              State_Id :event[0].State_Id,
              City_Id :event[0].City_Id,
              FullName :event[0].FullName,
              PinCode :event[0].PinCode,
              FlatHouseNoBuildingCompanyApartment :event[0].FlatHouseNoBuildingCompanyApartment,
              AreaColonyStreetSectorVillage :event[0].AreaColonyStreetSectorVillage,
              LandMark :event[0].LandMark,
              SetDefault : event[0].SetDefault=0? 'NO':'YES' ,
              IsBillShippingAddressSame: "NO",

            });

          }
        });



      // this.ConsignorForm.setValue({

      //   ConsignorId : id,
      //   //Country_Id :101,
      //   MobileNumber:comp.MobileNumber,
      //   State_Id :comp.State_Id,
      //   City_Id :comp.City_Id,
      //   FullName :comp.FullName,
      //   PinCode :comp.PinCode,
      //   FlatHouseNoBuildingCompanyApartment :comp.FlatHouseNoBuildingCompanyApartment,
      //   AreaColonyStreetSectorVillage :comp.AreaColonyStreetSectorVillage,
      //   LandMark :comp.LandMark,
      //   SetDefault : comp.SetDefault=0? 'NO':'YES' ,


      // });


    }


    deleteAddressBilling(id){

      var objj = new ConsignorElement();

        objj.ConsignorId =id;
        objj.OperationType= "delete";
        objj.CreatedBy = Number(sessionStorage.getItem("UID"));


      this.cnorService.insertConsignorData(objj).subscribe((event: any) => {
        if (event && event.length > 0) {
           //console.log(event);
         // if (event[0].OperationStatus == "Successfully Deleted") {

            //this.alertmsg = "Deleted !";

            this.alertmsg = (event[0].OperationStatus);
            this.showalert = true;
            setTimeout(() => {
              this.showalert = false;
            }, 3000);

            this.ConsignorForm.reset();
            this.FillBillingAddressData();
            this.operationstate=0;

         // }
         // else
          //{
            //this.alertmsg = event[0].OperationStatus;
            this.ConsignorForm.reset();
            this.FillBillingAddressData();
            this.operationstate=0;

          //}



        }
      });

    }





    editAddressShipping(id){

      this.IDS=id;
      this.operationstate=1;
      var comp = null;
      this.cneeService
        .getAllConsigneeMasterByConsigneeIdData(id)
        .subscribe((event: any) => {
          if (event.length > 0) {
            comp = event;

            // this.shareService.getAllFillStateByCountryIdData(event.CountryId)
            // .subscribe(
            //  (datast2) => {
            // this.stateData = datast2;}
            //  );

             this.shareService.getAllFillCityByStateIdData(event.StateId)
             .subscribe(
               (datact3) => {
             this.cityData = datact3; }
             );

              // if (event[0].OperationStatus == "Successfully Saved") {
             //   alert("done");
            // }
            this.ConsigneeForm.setValue({

              ConsigneeId : id,
              //Country_Id :101,
              MobileNumber:event[0].MobileNumber,
              State_Id :event[0].State_Id,
              City_Id :event[0].City_Id,
              FullName :event[0].FullName,
              PinCode :event[0].PinCode,
              FlatHouseNoBuildingCompanyApartment :event[0].FlatHouseNoBuildingCompanyApartment,
              AreaColonyStreetSectorVillage :event[0].AreaColonyStreetSectorVillage,
              LandMark :event[0].LandMark,
              SetDefault : event[0].SetDefault=0? 'NO':'YES' ,


            });

          }
        });



      // this.ConsignorForm.setValue({

      //   ConsignorId : id,
      //   //Country_Id :101,
      //   MobileNumber:comp.MobileNumber,
      //   State_Id :comp.State_Id,
      //   City_Id :comp.City_Id,
      //   FullName :comp.FullName,
      //   PinCode :comp.PinCode,
      //   FlatHouseNoBuildingCompanyApartment :comp.FlatHouseNoBuildingCompanyApartment,
      //   AreaColonyStreetSectorVillage :comp.AreaColonyStreetSectorVillage,
      //   LandMark :comp.LandMark,
      //   SetDefault : comp.SetDefault=0? 'NO':'YES' ,


      // });


    }


    deleteAddressShipping(id){

      var objj = new ConsigneeElement();

        objj.ConsigneeId =id;
        objj.OperationType= "delete";
        objj.CreatedBy = Number(sessionStorage.getItem("UID"));


      this.cneeService.insertConsigneeData(objj).subscribe((event: any) => {
        if (event && event.length > 0) {
           //console.log(event);
         // if (event[0].OperationStatus == "Successfully Deleted") {

            //this.alertmsg = "Deleted !";

            this.alertmsg = (event[0].OperationStatus);
            this.showalert = true;
            setTimeout(() => {
              this.showalert = false;
            }, 3000);

            this.ConsigneeForm.reset();
            this.FillShippingAddressData();
            this.operationstate=0;

         // }
         // else
          //{
            //this.alertmsg = event[0].OperationStatus;
            this.ConsigneeForm.reset();
            this.FillShippingAddressData();
            this.operationstate=0;

          //}



        }
      });

    }



    firstValChange(val) {
      if (!isNaN(parseInt(val.currentTarget.value))) {
        var firstVal = this.ConsignorForm.value.MobileNumber;

        this.IP=firstVal.length;

        if (firstVal != 0) {

          this.ConsignorForm.patchValue({
          SavePriceAmount: firstVal - parseInt(val.currentTarget.value),
          SavePricePercent:
            ((firstVal - parseInt(val.currentTarget.value)) / firstVal) * 100,
          });

        }

      }
    }




  }
